// src/graphql/adminAuth.ts
import { gql } from "@apollo/client";

export const ADMIN_LOGIN_MUTATION = gql`
  mutation SignIn($email: String!, $password: String!) {
    signIn(input: { email: $email, password: $password }) {
      token
      user {
        id
        name
        email
        role
      }
      errors
    }
  }
`;
